import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useConfiguracoes = () => {
  return useQuery({
    queryKey: ["configuracoes_gerais"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("public-config");
      if (error) throw error;
      return (data as Record<string, string>) || {};
    },
  });
};
